import { Loadable } from '../../isLoading';
import { findLoadable } from '../../findLoadable';

export const findTeamIndex = (teams: string[][], uid?: Loadable<string>) => {
  return teams.findIndex((userIds) => {
    return findLoadable(userIds, uid);
  });
};
